import request from "../shared/http";
import appConfig from "../shared/js/app-config";

/**
 * Fetches aggregated dashboard metrics for the current service (tenant).
 */
class DashboardService {
  async fetchSummary(period = "7d") {
    const serviceId = appConfig.getServiceId();
    if (!serviceId) {
      throw new Error("No service selected");
    }
    const url = `/dashboard/${serviceId}`;
    try {
      // Axios resolves to { data, status, ... }; http transform puts API body in response.data
      const { data } = await request.get(url, { params: { period } });
      if (data && data.error) {
        throw new Error(data.error.message || "Could not load dashboard");
      }
      return data;
    } catch (e) {
      const msg =
        e?.response?.data?.error?.message ||
        e?.message ||
        "Could not load dashboard";
      throw new Error(msg);
    }
  }
}

export default new DashboardService();
